// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3BZ0j","title":"Images45_title__3yCl_","images":"Images45_images__cgtPB"};